import './PaymentProgressBar.css'

const PaymentProgressBar = ({ paidAmount, totalAmount, showLabel = true }) => {
  const percentage = totalAmount > 0 ? Math.min((paidAmount / totalAmount) * 100, 100) : 0
  const pendingAmount = totalAmount - paidAmount

  return (
    <div className="payment-progress-bar">
      {showLabel && (
        <div className="progress-label">
          <span>Pagado: ${paidAmount.toLocaleString()}</span>
          <span>Pendiente: ${pendingAmount.toLocaleString()}</span>
        </div>
      )}
      <div className="progress-bar-container">
        <div 
          className="progress-bar-fill" 
          style={{ width: `${percentage}%` }}
        >
          <span className="progress-percentage">{Math.round(percentage)}%</span>
        </div>
      </div>
    </div>
  )
}

export default PaymentProgressBar

